import api from "../../Environment";

/**
 * Phase B notification center client.
 */

function authParams(extra = {}) {
  const id = localStorage.getItem("userId");
  const token = localStorage.getItem("accessToken");
  return {
    id,
    token,
    ...extra,
  };
}

export async function fetchNotificationInbox(filters = {}) {
  try {
    const response = await api.postMethod(
      "notifications/inbox",
      authParams(filters)
    );
    const body = response && response.data;
    if (body && body.success) {
      return body.data || { items: [], unread_count: 0 };
    }
  } catch (e) {
    /* ignore */
  }
  return { items: [], unread_count: 0, total: 0 };
}

export async function markNotificationsRead({ notificationId, markAll } = {}) {
  try {
    const response = await api.postMethod(
      "notifications/mark-read",
      authParams({
        notification_id: notificationId,
        mark_all: markAll ? 1 : 0,
      })
    );
    const body = response && response.data;
    if (body && body.success) {
      return body.data;
    }
  } catch (e) {
    /* ignore */
  }
  return { ok: false, updated: 0 };
}

export async function dismissNotification({ notificationId, dismissAll } = {}) {
  try {
    const response = await api.postMethod(
      "notifications/dismiss",
      authParams({
        notification_id: notificationId,
        dismiss_all: dismissAll ? 1 : 0,
      })
    );
    const body = response && response.data;
    if (body && body.success) {
      return body.data;
    }
  } catch (e) {
    /* ignore */
  }
  return { ok: false, updated: 0 };
}

export async function fetchNotificationPreferences() {
  try {
    const response = await api.postMethod(
      "notifications/preferences",
      authParams()
    );
    const body = response && response.data;
    if (body && body.success) {
      return body.data;
    }
  } catch (e) {
    /* ignore */
  }
  return null;
}

export async function saveNotificationPreferences(preferences) {
  try {
    const response = await api.postMethod(
      "notifications/preferences",
      authParams({ preferences })
    );
    const body = response && response.data;
    if (body && body.success) {
      return body.data;
    }
  } catch (e) {
    /* ignore */
  }
  return null;
}

export async function fetchNotificationFoundation() {
  try {
    const response = await api.postMethod("notifications/foundation", {});
    const body = response && response.data;
    if (body && body.success) {
      return body.data;
    }
  } catch (e) {
    /* ignore */
  }
  return null;
}
